import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import BottomNav from './dashboard/BottomNav';

// Simple layout wrapper that adds bottom navigation to pages
export default function AppLayout({ children }) {
  return (
    <>
      <Box sx={{ pb: 10 }}>{children || <Outlet />}</Box>
      <BottomNav />
    </>
  );
}
